import { render } from "./PrimaryButton.vue?vue&type=template&id=3f7afe14&scoped=true"
import script from "./PrimaryButton.vue?vue&type=script&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&lang=js"

import "./PrimaryButton.vue?vue&type=style&index=0&id=3f7afe14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f7afe14"]])

export default __exports__